import React, { useEffect, useState } from 'react'
import { Chart } from "react-google-charts";
import HttpClient from '../../utils/HttpClient';
import toast from 'react-hot-toast';
import { FaSearch } from 'react-icons/fa'; // Import magnifying glass icon
import { useLanguage } from '../../Providers/LanguageContext';
import { GanttComponent } from '@syncfusion/ej2-react-gantt';
import GanttChartComponent from './GanttChartComponent/GanttChartComponent';
import { addDays } from 'date-fns';
import CustomGanttChart from './GanttChartComponent/CustomGanttChart';
import { duration } from 'moment';
import { useLocation } from 'react-router-dom';


const GanttChart = () => {
    const { language } = useLanguage();

    const columns = [
        { type: "string", label: "Task ID" },
        { type: "string", label: "Task Name" },
        { type: "string", label: "Resource" },
        { type: "date", label: "Start Date" },
        { type: "date", label: "End Date" },
        { type: "number", label: "Duration" },
        { type: "number", label: "Percent Complete" },
        { type: "string", label: "Dependencies" },
    ];


    const rows = [
        ["Sinter machine complex - #Task 1", "Sinter machine complex - #Task 1", "spring", new Date(2024, 2, 22), new Date(2024, 5, 20), null, 100, null],
        ["Replacing thermometer - #221455", "Replacing thermometer - #221455", "summer", new Date(2024, 5, 21), new Date(2024, 8, 20), null, 100, null],
        ["Sinter machine complex - #Task 2", "Sinter machine complex - #Task 2", "autumn", new Date(2024, 8, 21), new Date(2024, 11, 20), null, 100, null],
        ["2024Winter", "Sinter machine complex - #Task 3", "winter", new Date(2024, 11, 21), new Date(2024, 2, 21), null, 100, null],
        ["2024Spring", "Sinter machine complex - #Task 4", "spring", new Date(2024, 2, 22), new Date(2024, 5, 20), null, 50, null],
        ["2024Summer", "Sinter machine complex - #Task 5", "summer", new Date(2024, 5, 21), new Date(2024, 8, 20), null, 80, null],
    ];

    const [searchTerm, setSearchTerm] = useState('');
    // const [status, setStatus] = useState(["open", "doing", "done", "ideas", "onhold"]);
    const [originalGanttData, setOriginalGanttData] = useState([]); // Store original unfiltered data
    const [filterType, setFilterType] = useState('all'); // 'all', 'task', 'event', 'project'
    const data1 = [columns, ...rows];
    const [isLoading, setIsLoading] = useState(false);
    const [SyncFusionGanttChartData, setSyncFusionGanttChartDa] = useState([]);
    const [selectedProjectId, setSelectedProjectId] = useState('');

    const [formData, setFormData] = useState({
        fromDate: new Date().toISOString().split('T')[0], // Current date in YYYY-MM-DD format
        toDate: new Date().toISOString().split('T')[0],   // Current date in YYYY-MM-DD format
        status: [], // ["open", "doing", "done", "ideas", "onhold"]
    });


    const handleInputChange = e => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const fetchGanttChartData = async () => {
        setIsLoading(true);
        try {
            let data = {
                fromDate: formData?.fromDate,
                toDate: formData?.toDate,
                ...(formData?.status?.length && { status: [...formData.status] })
            };

            const res = await HttpClient.requestData("view-all-eventDetailsganttchart", "POST", data);

            if (res && res?.status) {
                setOriginalGanttData(res?.data || []);
            } else {
                toast.error(res?.message || "Something Went Wrong");
                setOriginalGanttData([]);
            }
        } catch (error) {
            console.error("Failed to fetch Gantt data:", error);
            toast.error("Failed to load chart data");
            setOriginalGanttData([]);
        } finally {
            setIsLoading(false);
        }
    };

    const handleFilterChange = (type) => {
        setFilterType(type);
    };

    useEffect(() => {
        fetchGanttChartData();
    }, []);

    useEffect(() => {
        if (formData.status?.length > 0) {
            // Filter both projects and their tasks based on status
            const filteredProjects = originalGanttData
                .map(project => {
                    // Filter tasks within each project
                    const filteredTasks = project.tasks?.filter(task =>
                        formData.status.includes(task.status)
                    ) || [];

                    // Include the project if:
                    // 1. It has matching status, OR
                    // 2. It has tasks with matching status (even if project status doesn't match)
                    if (formData.status.includes(project.status) || filteredTasks.length > 0) {
                        return {
                            ...project,
                            tasks: filteredTasks
                        };
                    }
                    return null;
                })
                .filter(project => project !== null); // Remove null entries

            // Convert filtered data to SyncFusion format
            const allTaskData = filteredProjects.map(project => project.tasks).flat(1);
            const updatedAllTaskData = allTaskData.map((task, i) => ({
                TaskID: (i + 1),
                TaskName: task?.title || '-',
                StartDate: task?.startDate ? new Date(task?.startDate) : '-',
                EndDate: task?.endDate ? new Date(task?.endDate) : '-',
                TeamMember: task?.TeamMember || '-',
                Progress: task?.Progress || 0,
                Duration: task?.duration || 0,
                projectId: task?.projectId || '', // Add this line
            }));

            setSyncFusionGanttChartDa(updatedAllTaskData);
        } else {
            fetchAllProjects();
        }
    }, [formData.status, originalGanttData]);

    // console.log('originalGanttData: ', originalGanttData);

    const handleSearch = (term) => {
        setSearchTerm(term);

        if (term.length === 0) {
            // If search term is empty, show all data with current filters
            return;
        }

        // Filter the original data based on search term
        const filteredData = originalGanttData.filter(item =>
            item?.title?.toLowerCase().includes(term.toLowerCase()) ||
            item?.description?.toLowerCase().includes(term.toLowerCase())
        );
    };


    const handleStatus = (val) => {
        setFormData(prev => {
            return {
                ...prev,
                status: [val],
            };
        });
    };

    // console.log('formData: ', formData);

    // const fetchAllProjects = () => {

    //     const allTaskData = originalGanttData?.map(project => project?.tasks).flat(1);
    //     // console.log('allTaskData: ', allTaskData);

    //     const updatedAllTaskData = allTaskData?.map((task, i) => ({
    //         TaskID: (i + 1),
    //         TaskName: task?.title || '-',
    //         StartDate: task?.startDate ? new Date(task?.startDate) : '-',
    //         EndDate: task?.endDate ? new Date(task?.endDate) : '-',
    //         TeamMember: task?.TeamMember || '-',
    //         Progress: task?.Progress || 0, // Add progress percentage (0-100)
    //         Duration: task?.duration || 0, // Duration in days
    //     }));
    //     setSyncFusionGanttChartDa(updatedAllTaskData);
    // };

    const fetchAllProjects = () => {
        const allTaskData = originalGanttData?.map(project =>
            project?.tasks?.map(task => ({
                ...task,
                projectId: project._id // Add projectId to each task
            }))
        ).flat(1);

        const updatedAllTaskData = allTaskData?.map((task, i) => ({
            TaskID: (i + 1),
            TaskName: task?.title || '-',
            StartDate: task?.startDate ? new Date(task?.startDate) : '-',
            EndDate: task?.endDate ? new Date(task?.endDate) : '-',
            TeamMember: task?.TeamMember || '-',
            Progress: task?.Progress || 0,
            Duration: task?.duration || 0,
            projectId: task?.projectId || '' // Ensure projectId is included
        }));
        setSyncFusionGanttChartDa(updatedAllTaskData);
    };

    useEffect(() => {
        if (originalGanttData?.length) {
            fetchAllProjects();
        }
    }, [originalGanttData]);


    // useEffect(() => {
    //     if (selectedProjectId?.length) {
    //         if (selectedProjectId === "all") {
    //             fetchAllProjects();
    //             setFormData(prevFormData => ({
    //                 ...prevFormData,
    //                 status: [],
    //             }))
    //         } else {
    //             const allTaskData = originalGanttData?.filter(project => project?.title?.trim() === selectedProjectId?.trim())?.map(project => project?.tasks).flat(1);
    //             // console.log('allTaskData: ', allTaskData);

    //             const updatedAllTaskData = allTaskData?.map((task, i) => ({
    //                 TaskID: (i + 1),
    //                 TaskName: task?.title || '-',
    //                 StartDate: task?.startDate ? new Date(task?.startDate) : '-',
    //                 EndDate: task?.endDate ? new Date(task?.endDate) : '-',
    //                 TeamMember: task?.TeamMember || '-',
    //                 Progress: task?.Progress || 0, // Add progress percentage (0-100)
    //                 Duration: task?.duration || 0, // Duration in days
    //             }));
    //             setSyncFusionGanttChartDa(updatedAllTaskData);
    //         }
    //     }
    // }, [selectedProjectId]);

    useEffect(() => {
        if (selectedProjectId?.length) {
            if (selectedProjectId === "all") {
                fetchAllProjects();
                setFormData(prevFormData => ({
                    ...prevFormData,
                    status: [],
                }))
            } else {
                const allTaskData = originalGanttData
                    ?.filter(project => project?.title?.trim() === selectedProjectId?.trim())
                    ?.map(project =>
                        project?.tasks?.map(task => ({
                            ...task,
                            projectId: project._id // Add projectId to each task
                        }))
                    ).flat(1);

                const updatedAllTaskData = allTaskData?.map((task, i) => ({
                    TaskID: (i + 1),
                    TaskName: task?.title || '-',
                    StartDate: task?.startDate ? new Date(task?.startDate) : '-',
                    EndDate: task?.endDate ? new Date(task?.endDate) : '-',
                    TeamMember: task?.TeamMember || '-',
                    Progress: task?.Progress || 0,
                    Duration: task?.duration || 0,
                    projectId: task?.projectId || '' // Ensure projectId is included
                }));
                setSyncFusionGanttChartDa(updatedAllTaskData);
            }
        }
    }, [selectedProjectId]);


    // console.log('SyncFusionGanttChartData: >>>> ', SyncFusionGanttChartData);


    // let SyncFusionGanttChartData = [
    //     {
    //         TaskID: 1,
    //         TaskName: 'Task 1',
    //         StartDate: new Date('01/02/2019'),
    //         EndDate: new Date('01/03/2019'),
    //         TeamMember: 'Alice',
    //         Progress: 80, // Add progress percentage (0-100)
    //         Duration: 30, // Duration in days
    //     },
    //     {
    //         TaskID: 2,
    //         TaskName: 'Task 2',
    //         StartDate: new Date('01/17/2019'),
    //         EndDate: new Date('01/31/2019'),
    //         TeamMember: 'Bob',
    //         Progress: 45,
    //         Duration: 14,
    //     }
    // ];

    let taskSettings = {
        id: 'TaskID',
        name: 'TaskName',
        startDate: 'StartDate',
        endDate: 'EndDate',
        duration: 'Duration',
        progress: 'Progress',
        resourceInfo: 'TeamMember',
        child: 'subtasks',
        dependency: 'Predecessor' // Add if you have dependencies
    };

    const ganttData = [
        {
            TaskID: 1,
            TaskName: 'Project Kickoff',
            StartDate: `${new Date('2023-01-01')}`,
            EndDate: `${new Date('2023-01-07')}`,
            Progress: 100,
            TeamMember: 'Management',
            Duration: 5
        },
        {
            TaskID: 2,
            TaskName: 'Design Phase',
            StartDate: `${new Date('2023-01-08')}`,
            EndDate: `${new Date('2023-01-21')}`,
            Progress: 75,
            TeamMember: 'Design',
            Duration: 5
        },
        {
            TaskID: 3,
            TaskName: 'Development',
            StartDate: `${new Date('2023-01-22')}`,
            EndDate: ` ${new Date('2023-02-18')}`,
            Progress: 25,
            TeamMember: 'Engineering',
            Duration: 5
        },

        {
            TaskID: 1,
            TaskName: 'Project Kickoff',
            StartDate: `${new Date('2023-01-01')}`,
            EndDate: `${new Date('2023-01-07')}`,
            Progress: 100,
            TeamMember: 'Management',
            Duration: 5
        },
        {
            TaskID: 2,
            TaskName: 'Design Phase',
            StartDate: `${new Date('2023-01-08')}`,
            EndDate: `${new Date('2023-01-21')}`,
            Progress: 75,
            TeamMember: 'Design',
            Duration: 5
        },
        {
            TaskID: 3,
            TaskName: 'Development',
            StartDate: `${new Date('2023-01-22')}`,
            EndDate: ` ${new Date('2023-02-18')}`,
            Progress: 25,
            TeamMember: 'Engineering',
            Duration: 5
        },
        {
            TaskID: 1,
            TaskName: 'Project Kickoff',
            StartDate: `${new Date('2023-01-01')}`,
            EndDate: `${new Date('2023-01-07')}`,
            Progress: 100,
            TeamMember: 'Management',
            Duration: 5
        },
        {
            TaskID: 2,
            TaskName: 'Design Phase',
            StartDate: `${new Date('2023-01-08')}`,
            EndDate: `${new Date('2023-01-21')}`,
            Progress: 75,
            TeamMember: 'Design',
            Duration: 5
        },
        {
            TaskID: 3,
            TaskName: 'Development',
            StartDate: `${new Date('2023-01-22')}`,
            EndDate: ` ${new Date('2023-02-18')}`,
            Progress: 25,
            TeamMember: 'Engineering',
            Duration: 5
        },
        {
            TaskID: 1,
            TaskName: 'Project Kickoff',
            StartDate: `${new Date('2023-01-01')}`,
            EndDate: `${new Date('2023-01-07')}`,
            Progress: 100,
            TeamMember: 'Management',
            Duration: 5
        },
        {
            TaskID: 2,
            TaskName: 'Design Phase',
            StartDate: `${new Date('2023-01-08')}`,
            EndDate: `${new Date('2023-01-21')}`,
            Progress: 75,
            TeamMember: 'Design',
            Duration: 5
        },
        {
            TaskID: 3,
            TaskName: 'Development',
            StartDate: `${new Date('2023-01-22')}`,
            EndDate: ` ${new Date('2023-02-18')}`,
            Progress: 25,
            TeamMember: 'Engineering',
            Duration: 5
        },
    ];

    const columns65 = [
        { field: 'TaskID', headerText: 'ID', width: 60 },
        { field: 'TaskName', headerText: 'Task Name', width: 200 },
        { field: 'TeamMember', headerText: 'Team', width: 120 },
        { field: 'Progress', headerText: 'Percentage Done', width: 150 },
        { field: 'Duration', headerText: 'Days', width: 100 },
        { field: 'StartDate', headerText: 'Start Date', width: 120, format: 'dd-MMM-yyyy' },
        { field: 'EndDate', headerText: 'End Date', width: 120, format: 'dd-MMM-yyyy' },
    ];

    const taskFields = {
        id: 'TaskID',
        name: 'TaskName',
        startDate: 'StartDate',
        endDate: 'EndDate',
        progress: 'Progress',
        resourceInfo: 'TeamMember',
        duration: 'Duration',
        child: 'subtasks'
    };

    // Correct tasks data for gantt-task-react
    const tasks = [
        {
            id: "Task 1",
            name: "Sinter machine complex - #Task 1",
            start: new Date(2024, 2, 22),
            end: new Date(2024, 5, 20),
            progress: 100,
            type: "task",
            styles: { progressColor: '#ffbb54', progressSelectedColor: '#ff9e0d' },
        },
        {
            id: "Task 2",
            name: "Replacing thermometer - #221455",
            start: new Date(2024, 5, 21),
            end: new Date(2024, 8, 20),
            progress: 100,
            type: "task",
        },
        {
            id: "Task 3",
            name: "Sinter machine complex - #Task 2",
            start: new Date(2024, 8, 21),
            end: new Date(2024, 11, 20),
            progress: 100,
            type: "task",
        },
        {
            id: "Task 4",
            name: "Sinter machine complex - #Task 3",
            start: new Date(2024, 11, 21),
            end: new Date(2025, 2, 21),
            progress: 100,
            type: "task",
        },
        {
            id: "Task 5",
            name: "Sinter machine complex - #Task 4",
            start: new Date(2024, 2, 22),
            end: new Date(2024, 5, 20),
            progress: 50,
            type: "task",
        },
        {
            id: "Task 6",
            name: "Sinter machine complex - #Task 5",
            start: new Date(2024, 5, 21),
            end: new Date(2024, 8, 20),
            progress: 80,
            type: "task",
        }
    ];
    const location = useLocation();

    // console.log('SyncFusionGanttChartData: ', SyncFusionGanttChartData);
    return (
        <>
            {
                location.pathname !== "/favourite-dashboard" && (
                    <div className='chart_title_div'>Gantt Chart Analytics</div>
                )
            }

            <div className=' mt-3' style={{
                border: '4px solid #fff',
                padding: '30px',
                borderRadius: '25px'
            }}>
                <p style={{
                    fontSize: '18px',
                    fontWeight: '500',
                    color: location?.pathname !== "/favourite-dashboard" ? 'black' : "black",
                    marginTop: '15px',
                }}>Status</p>

                <div className={location?.pathname !== "/favourite-dashboard" ? 'status_tabs_Wrapper' : 'status_tabs_Wrapper_fav_dashboard'} style={{
                    width: '100%'
                }}>
                    <p
                        onClick={() => handleStatus("open")}
                        className={formData.status?.includes('open') ? 'status_tabs_Wrapper_highlight' : ''}
                    >
                        Open
                    </p>
                    <p
                        onClick={() => handleStatus("doing")}
                        className={formData.status?.includes('doing') ? 'status_tabs_Wrapper_highlight' : ''}
                    >
                        Doing
                    </p>
                    <p
                        onClick={() => handleStatus("done")}
                        className={formData.status?.includes('done') ? 'status_tabs_Wrapper_highlight' : ''}
                    >
                        Done
                    </p>
                    <p
                        onClick={() => handleStatus("ideas")}
                        className={formData.status?.includes('ideas') ? 'status_tabs_Wrapper_highlight' : ''}
                    >
                        Ideas
                    </p>
                    <p
                        onClick={() => handleStatus("onhold")}
                        className={formData.status?.includes('onhold') ? 'status_tabs_Wrapper_highlight' : ''}
                    >
                        On-hold
                    </p>
                </div>

                <div className='gantt_date_wrapper' >
                    <div className='gantt_input_Wrapper' style={{ position: 'relative' }}>
                        <label>Search Project</label>
                        {/* <div style={{ position: 'relative' }}>
                        <input
                            type='text'
                            placeholder={language.Search_Project}
                            value={searchTerm}
                            onChange={(e) => handleSearch(e.target.value)}
                            style={{ paddingLeft: '30px' }}
                        />
                        <FaSearch
                            style={{
                                position: 'absolute',
                                left: '10px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                color: '#666'
                            }}
                        />
                    </div> */}
                        <select
                            onChange={(e) => setSelectedProjectId(e.target.value)}
                        >
                            <option value={''}>Select Project</option>
                            <option value={'all'}>All Projects</option>
                            {
                                originalGanttData?.length > 0 ? originalGanttData?.map((project, i) => (
                                    <option key={i} value={project?.title}>{project?.title}</option>
                                )) : (<option value={''}>No Projects Found</option>)
                            }

                        </select>
                    </div>
                    <div className='gantt_input_Wrapper'>
                        <label>Start Date</label>
                        <input type='date' value={formData.fromDate} name='fromDate' onChange={handleInputChange} />
                    </div>

                    <div className='gantt_input_Wrapper'>
                        <label>End Date</label>
                        <input type='date' value={formData.toDate} name='toDate' onChange={handleInputChange} />
                    </div>

                    <div className='gantt_input_Wrapper' style={{
                        // marginLeft: "auto",
                        marginTop: '32px',
                    }}>
                        <div style={{
                            background: '#0c2637',
                            color: '#fff',
                            cursor: 'pointer',
                        }} className='filter_button5625' onClick={fetchGanttChartData}>Submit</div>
                    </div>
                    {/* <div className='gantt_input_Wrapper'>
                    <label>End Date</label>
                    <select>
                        <option>Project1</option>
                        <option>Project1</option>
                        <option>Project1</option>
                    </select>
                </div> */}

                </div>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    {
                        formData?.fromDate && formData?.toDate && (
                            <div style={{
                                color: '#000',
                                fontSize: '15px',
                                fontWeight: '500'
                            }}>
                                {new Date(formData?.fromDate).toLocaleString('default', { month: 'long' })} {new Date(formData?.fromDate)?.getFullYear()} - {new Date(formData?.toDate).toLocaleString('default', { month: 'long' })} {new Date(formData?.toDate)?.getFullYear()}
                            </div>
                        )
                    }
                    {/* <div className='gantt_input_Wrapper' style={{
                    marginLeft: "auto",
                    marginTop: '10px',
                }}>
                    <div style={{
                        background: '#ffdd00',
                        cursor: 'pointer'
                    }} className='filter_button5625'>Filter</div>
                </div> */}
                    <div className='gantt_input_Wrapper d-none'>
                        <label>End Date</label>
                        <select
                            value={filterType}
                            onChange={(e) => handleFilterChange(e.target.value)}
                        >
                            <option value={'all'}>All</option>
                            <option value={'task'}>Task</option>
                            <option value={'event'}>Event</option>
                            <option value={'project'}>Project</option>
                        </select>
                    </div>
                </div>

                {/* <div className='gantt_chart_Wrapper'>
                {isLoading ? (
                    <div>Loading chart...</div>
                ) : (
                    <Chart
                        chartType="Gantt"
                        width="100%"
                        height="500px"
                        data={data}
                        // options={options}
                    />
                )}
            </div> */}

                <div className='gantt_chart_Wrapper' style={{
                    marginTop: '20px'
                }}>

                    {/* <GanttComponent
                    columns={[
                        { field: 'TaskID', headerText: 'Id', width: 80 },
                        { field: 'TaskName', headerText: 'Task Name', width: 200 },
                        { field: 'TeamMember', headerText: 'Team Member', width: 140 },
                        { field: 'Progress', headerText: 'Percentage Done', width: 150 },
                        { field: 'Duration', headerText: 'Days', width: 100 },
                        { field: 'StartDate', headerText: 'Start Date', width: 120, format: 'dd-MMM-yyyy' },
                        { field: 'EndDate', headerText: 'End Date', width: 120, format: 'dd-MMM-yyyy' },
                    ]}
                    dataSource={SyncFusionGanttChartData}
                    treeColumnIndex={1}
                    taskFields={taskSettings}
                    height='450px'
                    allowSelection={true}
                    highlightWeekends={true}
                    timelineSettings={{
                        timelineViewMode: 'Week',
                        topTier: {
                            unit: 'Month',
                            format: 'MMM yyyy'
                        },
                        bottomTier: {
                            unit: 'Day',
                            count: 1
                        }
                    }}
                    labelSettings={{
                        rightLabel: 'Progress',
                        taskLabel: 'Progress'
                    }}
                    progressBarBackgroundColor='#ddd'
                    progressBarHeight={20}
                    taskbarHeight={20}
                ></GanttComponent> */}
                    {/* <GanttChartComponent tasks={tasks} startDate={startDate} endDate={endDate}/> */}

                    <CustomGanttChart
                        // data={ganttData}
                        data={SyncFusionGanttChartData?.map(item => ({
                            ...item,
                            StartDate: `${item?.StartDate}`,
                            EndDate: `${item?.EndDate}`,
                        }))}
                        columns={columns65}
                        taskFields={taskFields}
                        height="600px"
                        timelineViewMode="Week"
                        allowSelection={true}
                        highlightWeekends={true}
                        showTooltip={true}
                        originalGanttData={originalGanttData} // Add this line
                    />

                </div>
            </div>

        </>
    )
}

export default GanttChart
